export default __webpack_public_path__ + "static/media/play-store.b544ca84.svg";